import { AppHostLoadingControl, ErrorCatDarkIcon, ErrorCatLightIcon, } from '@office-start/app-host-ui-controls';
import { useIsDarkMode } from '@office-start/theming-service';
import React from 'react';
export class AppHostHubUiService {
    constructor(correlationId, refreshCallBack, locStrings, telemetry, appId) {
        this.renderErrorImage = () => {
            const isDarkMode = useIsDarkMode();
            return isDarkMode ? (React.createElement(ErrorCatDarkIcon, { width: "auto", height: "33vh", viewBox: "0 0 280 280" })) : (React.createElement(ErrorCatLightIcon, { width: "auto", height: "33vh", viewBox: "0 0 280 280" }));
        };
        this.getLoadingUi = () => {
            return React.createElement(AppHostLoadingControl, { label: this.locStrings.loadingLabel });
        };
        this.getErrorUiData = (reason) => {
            this.telemetry.logTelemetryEvent(`AppHostHubUiServiceFail: ${reason}`, this.appId);
            return {
                localizedErrorStrings: {
                    errorHeading: this.locStrings.errorUiTitle,
                    errorSubtitle: this.locStrings.errorUiLabel,
                    bubbleHeading: this.locStrings.errorUiTitle,
                    bubbleSubtitle: this.locStrings.errorUiLabel,
                    retryButtonTitle: this.locStrings.retryButtonTitle,
                    openInDesktopButtonTitle: '',
                    openInWebBrowserButtonTitle: '',
                    openInLegacyBrowserButtonTitle: '',
                },
                errorImage: {
                    image: this.renderErrorImage(),
                    altText: '',
                },
                retry: this.refreshCallBack,
            };
        };
        this.correlationId = correlationId;
        this.refreshCallBack = refreshCallBack;
        this.locStrings = locStrings;
        this.telemetry = telemetry;
        this.appId = appId;
    }
}
//# sourceMappingURL=AppHostHubUiService.js.map